import { project2BaseUrl } from "./remoteClient";

export async function requestSkillProfiles(token) {

    return await project2BaseUrl.get('skillProfiles/getSkillProfiles', {
        headers: {
            Authorization: `Bearer ${token}`
        }
    })
}

export async function createSkillProfile(token, skillProfile) {
    return await project2BaseUrl.post('skillProfiles/createSkillProfile', skillProfile, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    })
}

export async function updateSkillProfile(token, skillProfile) {
    return await project2BaseUrl.post('skillProfiles/updateSkillProfile', skillProfile, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    })
}

export async function deleteSkillProfile(token, profileId) {
    return await project2BaseUrl.post('skillProfiles/deleteSkillProfile', profileId, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    })
}

export async function getSkillProfileSkills(token, profileId) {
    return await project2BaseUrl.get('skillProfiles/getSkillProfileSkills?profileId=' + profileId, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    })
}

export async function updateSkillProfileSkills(token, profileId, skills) {
    return await project2BaseUrl.post('skillProfiles/updateSkillProfileSkills?profileId=' + profileId, skills, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    })
}

export async function createSkillProfileSkills(token, profileId, skills) {
    return await project2BaseUrl.post('skillProfiles/createSkillProfileSkills?profileId=' + profileId, skills, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    })
}